import EventEmitter from "../classes/EventEmitter.js";
import { Hatch, Domifier } from "../classes/Hatch";

const validPositions = ["relative", "absolute", "fixed"];

let resolveAttributes = (el: Element, ow = []) => {
  let r = {};
  Object.entries(el?.attributes || {}).forEach((attr) => {
    let a = attr[1];
    if (a.name.indexOf("data-") > -1) {
      let n = a.name.replace("data-", "");
      if (ow.indexOf(n) > -1) r[n] = a.value;
    }
  });
  return r;
};

export default class Tooltip extends EventEmitter {
  props: {
    text: string;
    target: HTMLElement;
    position: string;
  };
  view: HTMLElement;
  disabled: boolean = false;
  // creates the class
  constructor(props = {}) {
    super();
    // extract object configuration and extend with defaults
    let { target } = (this.props = {
      text: "Tooltip",
      target: null,
      position: "bottom",
      ...props,
    });

    // read out data-attributes and extend to existing props
    this.props = {
      ...this.props,
      ...resolveAttributes(target, Object.keys(this.props)),
    };

    this.view = null;

    if (target !== null) this.createBindings();
  }

  // spits out the view html
  render() {
    let { text, position } = this.props;
    return Domifier(
      Hatch`
      <div class="tooltip position-${position}">${text}</div>
    `.toString()
    ) as HTMLElement;
  }

  // attaches the event listeners to the target
  createBindings() {
    let { target } = this.props;
    target.addEventListener("mouseenter", () => this.show());
    target.addEventListener("mouseleave", () => this.hide());
  }

  disable() {
    this.disabled = true;
  }

  // appends tooltip view to parent target
  append() {
    let { target } = this.props;
    let pos: {
      x: number;
      y: number;
    };
    this.view = this.render();
    document.body.appendChild(this.view);

    const margin = 20;

    // tooltip is transformed 50% on selected axis. Its top,left determine its centered position.
    const tBounds = this.props.target.getBoundingClientRect();
    const vBounds = this.view.getBoundingClientRect();
    let xCenter = tBounds.left + tBounds.width / 2;
    const yTop = tBounds.top - vBounds.height - margin;
    const xRight = tBounds.left + tBounds.width + margin;
    const xLeft = tBounds.left - vBounds.width - margin;
    const yBottom = tBounds.top + tBounds.height + margin;
    let yCenter = tBounds.top + tBounds.height / 2;
    const vHalfX = vBounds.width / 2;
    const vHalfY = vBounds.height / 2;
    switch (this.props.position) {
      case "bottom":
        if (xCenter < vHalfX) {
          xCenter = vHalfX;
        }
        pos = {
          x: xCenter,
          y: yBottom,
        };
        break;
      case "top":
        if (xCenter < vHalfX) {
          xCenter = vHalfX;
        }
        pos = {
          x: xCenter,
          y: yTop,
        };
        break;
      case "right":
        if (yCenter < vHalfY) {
          yCenter = vHalfY;
        }
        pos = {
          x: xRight,
          y: yCenter,
        };
        break;
      case "left":
        if (yCenter < vHalfY) {
          yCenter = vHalfY;
        }
        pos = {
          x: xLeft,
          y: yCenter,
        };
        break;
      default:
        pos = {
          x: xCenter,
          y: yBottom,
        };
    }

    const yDiff = document.querySelector("html").scrollTop;
    this.view.style.left = pos.x + "px";
    this.view.style.top = pos.y + yDiff + "px";

    if (validPositions.indexOf(target.style.position) <= -1 && window.getComputedStyle(target).position !== "absolute")
      target.style.position = "relative";
  }

  show() {
    if (this.disabled) return;
    if (this.view !== null) return;
    this.view = this.render();
    this.append();
  }

  hide() {
    if (this.disabled) return;
    if (this.view) {
      this.view.remove();
      this.view = null;
    }
  }
}
